<template>
  <e-dialog
    :dialog-title="title"
    :center-dialog-visible="visible"
    :popup-width="'1200px'"
    :destroy-close="true"
    :modal-append-to-body="true"
    :show-btn="itemData.type !== 'detail'"
    @resetPopupData="onCancel"
    @submitPopupData="onOk"
  >
    <product-carbon-footprint
      v-if="itemData.key === 'carbonReportList'"
      :ref="itemData.ref"
      :key="formReloadKey"
      :report="itemData.reportList || []"
      :readonly="itemData.type === 'detail'"
      structure-locked
    />
  </e-dialog>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog.vue';
import ProductCarbonFootprint from './components/productCarbonFootprint.vue';

export default {
  components: {
    eDialog,
    ProductCarbonFootprint,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    itemData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formReloadKey: 0,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.formReloadKey += 1;
      }
    },
  },
  methods: {
    onCancel() {
      this.$emit('update:visible', false);
    },
    onOk() {
      const { ref } = this.itemData;
      const formVm = this.$refs[ref];
      if (!formVm || typeof formVm.submit !== 'function') {
        return;
      }
      formVm
        .submit()
        .then((res) => {
          if (!res || !res.success) {
            return;
          }
          const payload = res.data || {};
          const rows = payload.carbonReportList || [];
          const data = rows.length > 0 ? { ...rows[0] } : {};
          if (rows.length > 1) {
            data.carbonReportChildrenList = rows.slice(1);
          }
          this.$emit('submitPopupData', {
            success: true,
            data,
            id: this.itemData.id,
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__footer {
  padding: 20px;
}
::v-deep .el-dialog__body {
  max-height: 70vh;
  min-height: 420px;
  overflow-y: auto;
  padding-bottom: 0;
}
</style>
